import { render, staticRenderFns } from "./AStaffDetailAccessControl.vue?vue&type=template&id=7cdb2dbe&scoped=true"
import script from "./AStaffDetailAccessControl.vue?vue&type=script&lang=js"
export * from "./AStaffDetailAccessControl.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailAccessControl.vue?vue&type=style&index=0&id=7cdb2dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdb2dbe",
  null
  
)

export default component.exports